module.exports = __webpack_public_path__ + "static/img/slaflow2.1aa1857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaflow2.png
// module id = N6Jq
// module chunks = 2